import { actionTypes } from "react-redux-firebase";

const initState = {
  transactionsRetrieved: false,
  transactions: []
}

const billingReducer = (state = initState, action) => {
  switch (action.type) {
    case 'BILLING_RETRIEVED':
      console.log('billing retrieved');
      
      return {
        ...state,
        cardOnFile: action.cardOnFile,
        nextBillingPeriod: action.nextBillingPeriod,
        trialEndDate: action.trialEndDate
      }

    case 'BILLING_TRANSACTIONS_RETRIEVED':
      console.log('billing transactions retrieved');
      
      return {
        ...state,
        transactionsRetrieved: true,
        transactions: action.transactions
      }

      case 'BILLING_INFO_RETRIEVED':
      console.log('billing transactions retrieved');
      
      return {
        ...state,
        cardOnFile: action.cardOnFile
      }

    case 'PLAN_ADDED':
      console.log('billing transactions retrieved');
      
      return {
        ...state,
        billingPlan: action.billingPlan
      }
    
    default:
      return state;
  }
};

export default billingReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/billingReducer.js